export default function () {
    return {
        privacyPolicy: {
            id: null,
            content: null
        },
        errors: {
            'content': null
        },
        success: false
    }
}
